var _rect, _rect2, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3, _rect7, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33.8054,
    width: 13.3168,
    height: 45.204,
    rx: 2,
    fill: "#FDCF17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3303,
    cy: 71.8012,
    r: 4.0317,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0317,
    y: 38.6924,
    width: 5.13126,
    height: 22.4798,
    rx: 2,
    fill: "#D1A90A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3168,
    y: 33.8054,
    width: 13.3168,
    height: 45.204,
    rx: 2,
    fill: "#F14F4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6471,
    cy: 71.8012,
    r: 4.0317,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3484,
    y: 38.6924,
    width: 5.13126,
    height: 22.4798,
    rx: 2,
    fill: "#D94743"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6337,
    y: 33.8054,
    width: 13.3168,
    height: 45.204,
    rx: 2,
    fill: "#0E9C4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.964,
    cy: 71.8012,
    r: 4.0317,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50.6653,
    y: 38.6924,
    width: 5.13126,
    height: 22.4798,
    rx: 2,
    fill: "#0D8D43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6785 28.3078V38.5703V41.8689C50.6785 43.8237 52.1446 43.1721 52.8776 42.602L58.1229 38.668C58.2075 38.6046 58.3104 38.5703 58.4162 38.5703H72.1355C72.1658 38.5703 72.1967 38.5673 72.2264 38.5617C78.4438 37.3735 80 32.456 80 30.1403C79.6091 22.419 72.914 20.1629 69.6153 20H58.3045C58.2704 20 58.2355 20.0037 58.2022 20.0109C51.7957 21.3934 50.5161 26.1145 50.6785 28.3078Z",
    fill: "#2F82E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.775 26.6348C70.2367 26.6348 70.5713 27.0751 70.4474 27.52C70.3634 27.8219 70.0884 28.0308 69.775 28.0308H63.8016C63.3398 28.0308 63.0053 27.5905 63.1291 27.1456C63.2131 26.8437 63.4881 26.6348 63.8016 26.6348H69.775ZM67.8076 35.2716C67.3596 35.2716 66.934 35.0752 66.6433 34.7343L63.3154 30.8321C63.1845 30.6785 63.1119 30.4836 63.1106 30.2818C63.1073 29.8063 63.4919 29.4191 63.9675 29.4191H65C65.4917 29.4191 65.8961 29.3323 66.2133 29.1588C66.5358 28.98 66.7764 28.7407 66.935 28.441C67.0936 28.136 67.1729 27.7968 67.1729 27.4235C67.1729 27.0186 67.0989 26.661 66.9508 26.3508C66.8028 26.0406 66.5675 25.7987 66.245 25.6251C65.9226 25.4516 65.497 25.3649 64.9683 25.3649H63.922C63.4023 25.3649 63.0247 24.871 63.1608 24.3695C63.2541 24.0259 63.566 23.7874 63.922 23.7874H64.9683C65.9041 23.7874 66.6812 23.9267 67.2997 24.2054C67.9183 24.4841 68.3809 24.889 68.6875 25.4201C68.9994 25.9512 69.1554 26.5927 69.1554 27.3446C69.1554 28.0019 69.0417 28.583 68.8144 29.0878C68.5871 29.5873 68.2196 29.9922 67.7121 30.3025C66.9502 30.7603 66.4852 31.8076 67.0604 32.4853L69.32 35.1481C69.3315 35.1616 69.3378 35.1788 69.3378 35.1966C69.3378 35.238 69.3042 35.2716 69.2628 35.2716H67.8076ZM69.7778 23.7874C70.2412 23.7874 70.5759 24.2304 70.4493 24.6761C70.3641 24.9763 70.0899 25.1834 69.7778 25.1834H65.1576C64.6958 25.1834 64.3613 24.7431 64.4851 24.2982C64.5692 23.9963 64.8442 23.7874 65.1576 23.7874H69.7778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.89da3c6b86320f2a1c0ba1ff37c2a8d2.svg";
export { ForwardRef as ReactComponent };